var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.634,
    height: 18.634,
    viewBox: "0 0 18.634 18.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plusIcon",
    transform: "translate(-1270.39 -303.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M1278.024,304.384a8.817,8.817,0,0,1,9.035,3.788,8.786,8.786,0,0,1,1.3,3.184,8.837,8.837,0,0,1-.014,3.44,8.814,8.814,0,0,1-6.958,6.9,8.838,8.838,0,0,1-3.44-.014,8.813,8.813,0,0,1-6.4-5.3,8.813,8.813,0,0,1-.48-5.1,8.781,8.781,0,0,1,1.33-3.173,8.824,8.824,0,0,1,5.627-3.725Z",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    y2: 9.792,
    transform: "translate(1279.716 308.137)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 9.791,
    transform: "translate(1274.812 313.041)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.f237abd92e8f4e33067423ef066829b3.svg";
export { ForwardRef as ReactComponent };